import { render, staticRenderFns } from "./previewMedia.vue?vue&type=template&id=17951172&scoped=true&"
import script from "./previewMedia.vue?vue&type=script&lang=js&"
export * from "./previewMedia.vue?vue&type=script&lang=js&"
import style0 from "./previewMedia.vue?vue&type=style&index=0&id=17951172&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17951172",
  null
  
)

export default component.exports